import type { JSX } from 'react';
import { Clinicians } from './Clinicians';
import { Organisation } from './Organisation';
import { Cohorts } from './Cohorts';

/**
 * The owner's administration area.
 *
 * It contains no patient data of any kind, and that is the point rather than an
 * oversight: an owner administers the organisation and reads none of its
 * clinical records. The note at the top says so, because an owner who opens
 * this expecting a list of patients should find the explanation here rather
 * than conclude something is broken.
 *
 * An owner who also treats patients assigns themselves to a cohort on the
 * Cohorts screen below, and then reads as a clinician — through an assignment
 * anybody can see, rather than through their role.
 */
export function Administration(): JSX.Element {
  return (
    <div className="admin">
      <p className="admin__banner">
        Administration covers your organisation, its people and its cohorts. It shows no scores, comments or patient names
        &mdash; to see a caseload, assign yourself to a cohort below.
      </p>

      <Organisation />
      <Clinicians />
      <Cohorts />
    </div>
  );
}
